import { data } from 'jquery';
import { requestDelete, requestGet, requestPost, requestPut, requestPostForm } from '../../../services/requests';
import { apiEndPoint } from '../../../services/endpoint';
/**
 * Supports all operations exposed by the user controller.
 */


export class UserService {

  constructor(authEndpoint) {
    this.authEndpoint = apiEndPoint;
  }


  validateUser = (data) => {
    const url = this.authUrl('/user/validate/');
    return requestPost(url, data)
  }

  sendOtp = (data) => {
    const url = this.authUrl('/otp/web/');
    return requestPost(url, data)
  }

  verifyOtp = (data) => {
    const url = this.authUrl('/otp/verify/web/');
    return requestPost(url, data)
  }


  login = (data) => {
    const url = this.authUrl('/login/');
    return requestPost(url, data)
  }

  getUserDetails = (id) => {
    const url = this.authUrl(`/user/${id}/info/`);
    return requestGet(url)
  }


  forgotPassword = (data) => {
    const url = this.authUrl('/forgot_password/otp/');
    return requestPost(url, data)
  }


  uploadIdentityverification = (data) => {
    const url = this.authUrl(`/user/identityverification/`);
    return requestPostForm(url, data)
  }

  saveResidentialAdress(data) {
    const url = this.authUrl('/user/residential/address/');
    return requestPost(url, data);
  }

  uploadResidentialAdress = (data) => {
    const url = this.authUrl(`/user/residential/document/`);
    return requestPostForm(url, data)
  }

  saveFirmAdress(data) {
    const url = this.authUrl('/user/firm/address/');
    return requestPost(url, data);
  }

  uploadFirmAdress = (data) => {
    const url = this.authUrl(`/user/firm/document/`);
    return requestPostForm(url, data)
  }

  saveBankDetailsAdress(data) {
    const url = this.authUrl('/user/bankdetails/info/');
    return requestPost(url, data);
  }

  uploadBankDetailsAdress = (data) => {
    const url = this.authUrl(`/user/bankdetails/document/`);
    return requestPostForm(url, data)
  }

  saveEducationalQualification(data) {
    let url = this.authUrl('/user/educationalqualification/info/');
    if (data.id) {
      url = this.authUrl(`/user/educationalqualification/info/${data.id}/`);
      return requestPut(url, data);
    }
    else {
      url = this.authUrl('/user/educationalqualification/info/');
      return requestPost(url, data);
    }

  }

  deleteEducationalQualification(id) {
    const url = this.authUrl(`/user/educationalqualification/info/${id}/`);
    return requestDelete(url);
  }

  uploadEducationalQualification(data, id) {
    const url = this.authUrl(`/user/educationalqualification/document/${id}/`);
    return requestPostForm(url, data)
  }


  saveExperience(data) {
    let url = this.authUrl('/user/experience/info/');
    if (data.id) {
      url = this.authUrl(`/user/experience/info/${data.id}/`);
      return requestPut(url, data);
    }
    else {
      url = this.authUrl('/user/experience/info/');
      return requestPost(url, data);
    }

  }

  uploadExperience(data, id) {
    const url = this.authUrl(`/user/experience/document/${id}/`);
    return requestPostForm(url, data)
  }

  deleteExperience(id) {
    const url = this.authUrl(`/user/experience/info/${id}/`);
    return requestDelete(url);
  }

  saveTraining(data) {
    let url = this.authUrl('/user/training/info/');
    if (data.id) {
      url = this.authUrl(`/user/training/info/${data.id}/`);
      return requestPut(url, data);
    }
    else {
      url = this.authUrl('/user/training/info/');
      return requestPost(url, data);
    }

  }

  uploadTraining(data, id) {
    const url = this.authUrl(`/user/training/document/${id}/`);
    return requestPostForm(url, data)
  }

  deleteTraining(id) {
    const url = this.authUrl(`/user/training/info/${id}/`);
    return requestDelete(url);
  }

  getAllUsers= () => {
    const url = this.authUrl(`/approval/`);
    return requestGet(url)
  }
  // login=() => {
  //   axios({
  //     url: `${apiEndPoint}/login/`,
  //     method: 'POST',
  //     headers: {
  //       "Content-Type": "application/json; charset=utf-8", 
  //       Accept: "application/json"
  //     },
  //     data: this.state.user
  //   }).then(async function(res){
  //     var data = {
  //       token: res.data.token,
  //       user: res.data.user
  //     }
  //     try {
  //       await AsyncStorage.setItem('token', JSON.stringify(data));
  //     } catch (error) {
  //         // Error saving data
  //     }
  //     this.props.navigation.navigate('Home')
  //   }.bind(this)).catch((error) => {
  //     console.log(error)
  //     Alert.alert(`Wrong username or password!`);
  //   });
  // }

  // forgotPassword = () => {
  //   let {user} = this.state;
  //   if(user.username){
  //     axios({
  //       url: `${apiEndPoint}/forgot_password/otp/`,
  //       method: 'POST',
  //       headers: {
  //         "Content-Type": "application/json; charset=utf-8", 
  //         Accept: "application/json"
  //       },
  //       data: {
  //         phone: user.username
  //       }
  //     }).then(function(res){
  //       this.setState({isVisible: true});
  //     }.bind(this)).catch((error) => {
  //       console.log(error)
  //       this.setState({isVisible: false});
  //     });
  //   }else{
  //     Alert.alert(`Please enter the username!`);
  //   }
  // }
  getUserDetailsByID = (id) => {
    const url = this.authUrl(`/user/${id}/approval/info/`);
    return requestGet(url)
  }
  approveRejectUserDocument= (data) => {
    let url = this.authUrl(`/approve/document/`);
    return requestPut(url, data)
  }
  approveRejectIdentifyVerification= (data) => {
    let url = this.authUrl(`/approve/identification/`);
    return requestPut(url, data)
  }
  approveRejectResidentileDetail= (data) => {
    let url = this.authUrl(`/approve/residential/`);
    return requestPut(url, data)
  }
  approveRejectFirmDetail= (data) => {
    let url = this.authUrl(`/approve/firm/`);
    return requestPut(url, data)
  }
  approveRejectEduAllDetail= (data) => {
    let url = this.authUrl(`/approve/education/all/`);
    return requestPut(url, data)
  }
  approveRejectExpAllDetail= (data) => {
    let url = this.authUrl(`/approve/experience/all/`);
    return requestPut(url, data)
  }
  approveRejectTrainAllDetail= (data) => {
    let url = this.authUrl(`/approve/training/all/`);
    return requestPut(url, data)
  }
  approveRejectVehicleAllDetail= (data) => {
    let url = this.authUrl(`/approve/vehicle/all/`);
    return requestPut(url, data)
  }
  approveRejectExpDetail= (data) => {
    let url = this.authUrl(`/approve/experience/`);
    return requestPut(url, data)
  }
  approveRejectEduDetail= (data) => {
    let url = this.authUrl(`/approve/education/`);
    return requestPut(url, data)
  }
  approveRejectTraDetail= (data) => {
    let url = this.authUrl(`/approve/training/`);
    return requestPut(url, data)
  }
  approveRejectBankDetail= (data) => {
    let url = this.authUrl(`/approve/bank/`);
    return requestPut(url, data)
  }
  approveRejectBusiness= (data) => {
    let url = this.authUrl(`/approve/primary/`);
    return requestPut(url, data)
  }
  downloadReportDetail = (data) => {
    let url = this.authUrl(`/download/report/`);
    return requestPost(url, data)
  }
  downloadResolutionDetail = (data) => {
    let url = this.authUrl(`/download/resolution/`);
    return requestPost(url, data)
  }
  downloadreferralDetail = (data) => {
    let url = this.authUrl(`/download/referral/`);
    return requestPost(url, data)
  }
  getResolutionData = () => {
    let url = this.authUrl(`/resolution/`);
    return requestGet(url)
  }
  getReferralData = () => {
    let url = this.authUrl(`/referral/data`);
    return requestGet(url)
  }
  downloadUserData = (data) => {
    let url = this.authUrl(`/download/userdata/${data.user_type}/`);
    return requestPost(url, data)
  }
  updareReferralData = (data) => {
    let url = this.authUrl(`/referral/update/`);
    return requestPut(url, data)
  }
  logout() {
    localStorage.clear();
  }

  authUrl(append) {
    return apiEndPoint + append;
  }
}
